module.exports = __webpack_public_path__ + "static/media/bg05.e0cd64be.png";